import IconFailBigRed from "@/components/icons/IconFailBigRed.vue";
import IconSuccessBigGreen from "@/components/icons/IconSuccessBigGreen.vue";
import IconWarning from "@/components/icons/IconWarning.vue";

import type { DataOrchestrationOutcome } from "@/models/orchestration";
import type { Component } from "vue";

export const ICON_FOR_CONDITION: Partial<
  Record<DataOrchestrationOutcome, Component>
> = {
  pass: IconSuccessBigGreen,
  fail: IconFailBigRed,
  "manual review": IconWarning,
};
